import React from 'react';
import AddIcon from '@material-ui/icons/Add';

const Add = (props) => <AddIcon {...props} />;

export default Add;
